import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {AccountResourceService} from "../../../shared/services/account-resource.service";

@Injectable()
export class EmployeeActivateService {

  constructor(private accountResourceService: AccountResourceService) {
  }

  checkActivation(key) {
    return this.accountResourceService.checkActivation(key);
  }

  activateAccount(body: Object): Observable<any> {
    return this.accountResourceService.confirm(body);
  }

}
